module.exports = __webpack_public_path__ + "img/space-introduce-5.1560a8d4.svg";